import { useEffect, useState } from 'react';

import { Icon, IconButton, Modal } from '@atom/mui';
import { TaskLocation } from '@atom/types/taskLocation';

import AssetSummaryTray from '../AssetSummaryTray';

import TaskMap from './TaskMap';
import TaskMapSidebar from './TaskMapSidebar';

import classes from './taskMapModal.module.css';

const styles = {
  modalContent: { padding: '0' },
};

export interface Props {
  open: boolean;
  onClose: () => void;
  handleAddLocationClickFromMap: () => void;
  handleEditLocationClickFromMap: (location: TaskLocation) => void;
  handleAddAssetClickFromMap: () => void;
  viewAssetId: string;
  setViewAssetId: (assetId: string) => void;
}

const TaskMapModal = ({
  open,
  onClose,
  handleAddLocationClickFromMap,
  handleEditLocationClickFromMap,
  handleAddAssetClickFromMap,
  viewAssetId,
  setViewAssetId,
}: Props) => {
  const [hoverId, setHoverId] = useState<string>('');
  const [selectedAssetId, setSelectedAssetId] = useState<string>(viewAssetId);

  useEffect(() => {
    setSelectedAssetId(viewAssetId);
  }, [viewAssetId]);

  const onTrayClose = () => {
    setHoverId('');
    setSelectedAssetId('');
    setViewAssetId('');
  };

  return (
    <Modal
      open={open}
      title={
        <div className={classes.modalHeader}>
          <div>Map</div>
          <IconButton onClick={onClose}>
            <Icon>close</Icon>
          </IconButton>
        </div>
      }
      contentStyle={styles.modalContent}
      width="xxxl"
      onCancel={onClose}
      disableFooter
    >
      <div className={classes.modalContent}>
        {selectedAssetId ? (
          <AssetSummaryTray assetId={selectedAssetId} onClose={onTrayClose} />
        ) : (
          <TaskMapSidebar
            setHoverId={setHoverId}
            selectedAssetId={selectedAssetId}
            setSelectedAssetId={setSelectedAssetId}
            handleAddLocationClickFromMap={handleAddLocationClickFromMap}
            handleEditLocationClickFromMap={handleEditLocationClickFromMap}
            handleAddAssetClickFromMap={handleAddAssetClickFromMap}
          />
        )}
        <div className={classes.mapContainer}>
          <TaskMap hoverId={hoverId} />
        </div>
      </div>
    </Modal>
  );
};

export default TaskMapModal;
